const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- ui-segmented ---
let __fez_component_0;
{
const KEYS = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 }
__fez_component_0 = class {
  PROPS = {
    options: Array,
    value: String,
    label: String,
    onchange: { type: Function, state: true, default: () => {} },
  }

  pick(id) {
    const option = this.props.options.find((item) => item.id === id)
    if (!option || option.disabled || id === this.props.value) return
    this.state.onchange(id)
  }

  // Moves the choice with the arrow keys, skipping disabled options, and keeps focus on it.
  key(event) {
    const options = this.props.options
    const enabled = options.filter((item) => !item.disabled)
    if (!enabled.length) return
    let next
    if (event.key === 'Home') next = enabled[0]
    else if (event.key === 'End') next = enabled[enabled.length - 1]
    else if (KEYS[event.key]) {
      const step = KEYS[event.key]
      const from = options.findIndex((item) => item.id === (event.target.closest('[data-id]')?.dataset.id || this.props.value))
      for (let i = 1; i <= options.length; i++) {
        const candidate = options[(from + step * i + options.length * i) % options.length]
        if (!candidate.disabled) {
          next = candidate
          break
        }
      }
    }
    if (!next) return
    event.preventDefault()
    this.find(`[data-id="${CSS.escape(next.id)}"]`)?.focus()
    this.pick(next.id)
  }

  // The chosen option is the one tab stop; with none chosen, the first that can be.
  beforeRender() {
    const options = this.props.options
    this.state.stop = options.some((item) => item.id === this.props.value) ? this.props.value : options.find((item) => !item.disabled)?.id
  }

  CSS = `:fez {
display:inline-block;max-width:100%;.seg{display:inline-flex;gap:2px;max-width:100%;padding:3px;border-radius:var(--radius-md);background:var(--color-bg-hover);overflow-x:auto;scrollbar-width:none}.seg-item{display:inline-flex;align-items:center;gap:var(--space-1);padding:5px var(--space-3);border:0;border-radius:var(--radius-sm);background:transparent;color:var(--color-text-muted);font:inherit;font-size:var(--text-sm);font-weight:var(--weight-semibold);white-space:nowrap;cursor:pointer;transition:color var(--duration-fast) var(--ease),background var(--duration-fast) var(--ease);&:hover{color:var(--color-text)}&.active{background:var(--color-bg-raised);color:var(--color-text);box-shadow:var(--shadow-sm)}&.off{color:var(--color-text-subtle);cursor:not-allowed}}
}`

  HTML = `<div class="seg" role="tablist" aria-label={props.label || null} onkeydown="fez.key(event)">
{#each props.options as option}
<button type="button" class="seg-item" class:active={option.id === props.value} class:off={option.disabled} role="tab" data-id={option.id} aria-selected={option.id === props.value ? 'true' : 'false'} aria-disabled={option.disabled ? 'true' : null} tabindex={option.id === state.stop ? '0' : '-1'} title={option.title || null} onclick="fez.pick('{option.id}')">
{#if option.icon}
<ui-icon name={option.icon} size="14"></ui-icon>
{/if}
{option.label}
</button>
{/each}
</div>`
};
}

Fez('ui-segmented', __fez_component_0);

export default __fez_component_0;
